import { memo, useCallback, useContext, useEffect, useState } from "react";
import {
    Stack,
    Box,
    Typography,
    Select,
    MenuItem,
    FormControl,
    TextField,
    IconButton,
    Modal,
    Fade,
    Button,
    Link,
    Grid,
    Divider
} from "@mui/material";
import { makeStyles } from '@mui/styles'
import DatePicker from "react-datepicker";
import moment from 'moment';
import { CubeContext } from "@cubejs-client/react";

import { ReactComponent as DropDownIcon } from "../../assets/icons/icon-angle-down.svg"
import { ReactComponent as EditIcon } from "../../assets/icons/icon_edit.svg";
import { ReactComponent as DeleteIcon } from "../../assets/icons/icon-delete.svg";
import { FIELD_TYPE_FILTERS, INPUT_TYPE_TEXT_FILTER_TYPES, DATE_INPUT_FILTER_TYPES } from "../../constants/filterType";
import AsyncSelectInput from "./Common/AsyncSelectInput";
import { getReportFilterData, CustomTooltip, removeReference } from "../../utils/Reusables";
import { useDispatch } from "react-redux";
import { reportActions } from "../../redux/reducers/report/reportReducer";
import AdditionalFilterForm from "./Common/AdditionalFilterForm";


const useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: "50%"
    },
    menuDropdownItem: {
        fontSize: '14px',
        color: '#202124',
        '&:hover': {
            backgroundColor: '#f6f6f6'
        }
    }
}))
const ReportFilterFormNew = ({ currentDataset, filterObj, filterList, filterIndex }) => {
    const classes = useStyles()
    const [fieldList, setFieldList] = useState([...currentDataset.measures, ...currentDataset.dimensions])
    const [member, setMember] = useState(filterObj.name ?? '')
    const [operator, setOperator] = useState(filterObj.operator)
    const [filterValues, setFilterValues] = useState(filterObj.values ? filterObj.values : [])
    const [deletePopup, setDeletePopup] = useState(false)
    const cubejsApi = useContext(CubeContext).cubejsApi
    const dispatch = useDispatch()
    //console.log(fieldList)
    const handleChangeOperator = useCallback((event) => {
        let newObj = { ...filterObj }
        newObj.operator = event.target.value
        setOperator(event.target.value)
        newObj.values = []
        setFilterValues(newObj.values)
        dispatch(reportActions.updateFilterByIndex({ filter: newObj, index: filterIndex }));
        //updateFilter(newObj, filterIndex)
    })

    const handleChangeMember = useCallback((event) => {
        let newObj = { ...filterObj }
        newObj.member = `${currentDataset.dataSetName}.${event.target.value}`
        let field = fieldList.find(obj => obj.name === event.target.value)
        setMember(event.target.value)
        newObj.type = field.type
        newObj.fieldType = field.dataSetType
        newObj.displayName = field?.displayName
        newObj.name = field.name
        newObj.operator = field?.type === "time" ? 'inDateRange' : 'equals'
        dispatch(reportActions.updateFilterByIndex({ filter: newObj, index: filterIndex }));
        //updateFilter(newObj, filterIndex)
    })

    const handleValuesChange = useCallback((event,operator,filterObj,extraFieldFlag = false) => {
        let newObj = { ...filterObj }
        const value = event.target ? event.target.value : event

        switch (operator) {
            case 'inDateRange':
            case 'notInDateRange':
                const [startDate, endDate] = value
                newObj.values[0] = startDate ? moment(startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss") : null
                newObj.values[1] = endDate ? moment(endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss") : null
                if(extraFieldFlag === false) setFilterValues([...value])
                break;
            case 'afterDate':
                newObj.values[0] = moment(value).startOf('day').format("YYYY-MM-DD HH:mm:ss")
                if(extraFieldFlag === false) setFilterValues([...newObj.values])
                break;
            case 'beforeDate':
                newObj.values[0] = moment(value).endOf('day').format("YYYY-MM-DD HH:mm:ss")
                if(extraFieldFlag === false) setFilterValues([...newObj.values])
                break;
            case 'equals#true':
                newObj.values = value
                if(extraFieldFlag === false) setFilterValues([...newObj.values])
                break;
            default:
                newObj.values = value.split('\n').filter(Boolean)
                if(extraFieldFlag === false) setFilterValues([...value.split('\n')])
                break;
        }
        //console.log(extraFieldFlag)
        if(extraFieldFlag !== false){
            dispatch(reportActions.updateExtraFilterByIndex({filterIndex,extraFilterIndex:extraFieldFlag, filterObj:newObj}))
        }else{
            dispatch(reportActions.updateFilterByIndex({ filter: newObj, index: filterIndex }));
        }
    })

    const handleAddToReport = useCallback(() => {
        let newObj = { ...filterObj }
        let maxOrder = Math.max(...filterList.map(obj => obj.orderPriority))
        newObj.onReport = true
        newObj.orderPriority = maxOrder + 1
        dispatch(reportActions.updateFilterByIndex({ filter: newObj, index: filterIndex }));
        //updateFilter(filterObj, filterIndex)
    })

    const onAdditionalFilter = useCallback(() => {
        let newObj = removeReference(filterObj)
        newObj.values = []
        newObj.conditionType = newObj.conditionType ?? 'and'
        let obj = {
            member:'',
            type:'',
            name:'',
            operator: '',
            fieldType:'',
            values:[]
        }
        //console.log(newObj.extraFilters)
        if(newObj.extraFilters){
            newObj.extraFilters.push(obj)     
        }else{
            newObj.extraFilters = [obj]          
        }
        dispatch(reportActions.updateFilterByIndex({ filter: newObj, index: filterIndex }));
    })

    const onDeleteFilter = useCallback(() => {
        setDeletePopup(false)
        dispatch(reportActions.deleteFilterByIndex({ index: filterIndex }));
        //updateFilter(null, filterIndex)
    })

    const handleCancelDelete = useCallback(() => {
        setDeletePopup(false)
    })

    const onExtraFieldChange = useCallback((event,type,extraFilterIndex) => {
        const value = event.target.value
        let newObj = {}
        switch(type){
            case 'member':
                let field = fieldList.find(obj => obj.name === value)
                newObj = {
                    member: `${currentDataset.dataSetName}.${field.name}`,
                    name: field.name,
                    operator: field?.type === "time" ? 'inDateRange' : 'equals',
                    values: [],
                    type: field.type,
                    fieldType: field.dataSetType
                }
                dispatch(reportActions.updateExtraFilterByIndex({filterIndex,extraFilterIndex, filterObj:newObj}))
                break;
            case 'operator':
                newObj = removeReference(filterObj)
                newObj.extraFilters[extraFilterIndex].operator = value
                newObj.extraFilters[extraFilterIndex].values = []
                dispatch(reportActions.updateExtraFilterByIndex({filterIndex,extraFilterIndex, filterObj:newObj.extraFilters[extraFilterIndex]}))
                break;
            case 'values':
                newObj = removeReference(filterObj)
                handleValuesChange(event,newObj.extraFilters[extraFilterIndex].operator,newObj.extraFilters[extraFilterIndex],extraFilterIndex)
                break;
            case 'delete':
                newObj = removeReference(filterObj)
                dispatch(reportActions.deleteExtraFilterByIndex({filterIndex,extraFilterIndex}))
                break;
            case 'conditionType':
                newObj = removeReference(filterObj)
                newObj.conditionType = value
                dispatch(reportActions.updateFilterByIndex({ filter: newObj, index: filterIndex }));
                break;
            default:
                console.log('New Type')
        }
        

    })

    const asyncFetchFn = useCallback((event, loaderFn, dataFn) => {
        getReportFilterData(event, { filterObj, cubejsApi, loaderFn, dataFn })
    })

    return <Grid container >
        {/* {
            filterObj && filterObj.member &&
            <Stack width="100%" style={{ textAlign: 'left' }}>
                <Box sx={{ pl: 0 }}>
                    <CustomTooltip title="Add To Report">
                        <IconButton color="primary" aria-label="Add To Report" component="span" className="hover-white form-icon-btn"
                            sx={{ p: 0, marginRight: 4 }}
                            onClick={handleAddToReport}>
                            <EditIcon className="filter-action-icon" />
                            <Typography variant="subtitle2" className="text-small" sx={{ pl: 1 }}> Add To Report</Typography>
                        </IconButton>
                    </CustomTooltip>
                    <CustomTooltip title="Delete Filter">
                        <IconButton color="primary" aria-label="Delete Filter" component="span" className="hover-white form-icon-btn"
                            sx={{ p: 0, marginRight: 4 }}
                            onClick={() => setDeletePopup(true)}>
                            <DeleteIcon className="filter-action-icon" />
                        </IconButton>
                    </CustomTooltip>
                </Box>
            </Stack>
        } */}
        <Grid item xs={12}>
            <FormControl fullwidth className="re-form-group">
                <Typography component={'label'} className="re-formgroup-label-sm" >Field Name</Typography>
                <Select
                    variant="outlined"
                    className="report_form_ui_input_select text-small pl-0"
                    id={"filterMember-" + filterIndex}
                    value={member}
                    onChange={handleChangeMember}
                    size='small'
                    IconComponent={DropDownIcon}
                    MenuProps={{
                        classes: {
                            root: `form-select-menu re-form-select-menulist`
                        }
                    }}
                >
                    {
                        fieldList.map(obj => (
                            <MenuItem key={`${filterObj.member}-${obj.displayName}`} className={classes.menuDropdownItem + " menu-item-small"} value={obj.name}>{obj.displayName}</MenuItem>
                        ))
                    }
                </Select>
            </FormControl>
        </Grid>
        
        <Grid item xs={12}>
            <FormControl fullwidth className="re-form-group">
                <Typography component={'label'} className="re-formgroup-label-sm" >Operation</Typography>
                <Select
                    variant="outlined"
                    className="report_form_ui_input_select text-small pl-0"
                    id={"filterOperation-" + filterIndex}
                    value={operator}
                    onChange={handleChangeOperator}
                    size='small'
                    IconComponent={DropDownIcon}
                    MenuProps={{
                        classes: {
                            root: `form-select-menu re-form-select-menulist`
                        }
                    }}
                >
                    {
                        FIELD_TYPE_FILTERS[filterObj.type]?.map(obj => (
                            <MenuItem key={`${filterObj.member}-${obj.value}`} className={classes.menuDropdownItem + " menu-item-small"} value={obj.value}>{obj.label}</MenuItem>
                        ))
                    }
                </Select>
            </FormControl>
        </Grid>
        {
            ['set', 'notSet'].indexOf(operator) < 0 
                && (INPUT_TYPE_TEXT_FILTER_TYPES.indexOf(operator) > -1 ||
                    DATE_INPUT_FILTER_TYPES.indexOf(operator) > -1 || 
                    ['inDateRange', 'notInDateRange'].indexOf(operator) > -1 ||
                    operator == 'equals#true') 
                && (
                <Grid item xs={12}>
                    <FormControl fullwidth className="re-form-group">
                        <>
                            {
                                INPUT_TYPE_TEXT_FILTER_TYPES.indexOf(operator) > -1 && (
                                    <>
                                        <Typography component={'label'} className="re-formgroup-label-sm" >Value</Typography>
                                        <TextField
                                            className="report_form_ui_input text-small"
                                            id={"operatorvalues-" + filterIndex}
                                            label=""
                                            multiline
                                            maxRows={4}
                                            value={filterValues.join('\n')}
                                            onChange={e => handleValuesChange(e, operator,filterObj)}
                                            variant="outlined"
                                            size='small'
                                        />
                                    </>
                                )
                            }
                            {
                                DATE_INPUT_FILTER_TYPES.indexOf(operator) > -1 && (
                                    <>
                                        <Typography component={'label'} className="re-formgroup-label-sm" >Date</Typography>
                                        <DatePicker dateFormat="dd/MM/yyyy" className="report_form_ui_input_date" maxDate={new Date()} selected={filterValues.length > 0 ? moment(filterValues[0]).toDate() : null} onChange={e => handleValuesChange(e, operator,filterObj)} isClearable={true} />
                                    </>
                                )
                            }
                            {
                                ['inDateRange', 'notInDateRange'].indexOf(operator) > -1 && (
                                    <>
                                        <Typography component={'label'} className="re-formgroup-label-sm" >Date Range</Typography>
                                        <DatePicker dateFormat="dd/MM/yyyy" className="report_form_ui_input_date" maxDate={new Date()} selectsRange={true} startDate={filterValues[0]} endDate={filterValues[1]} onChange={e => handleValuesChange(e, operator,filterObj)} isClearable={true} />
                                    </>
                                )
                            }
                            {
                                operator == 'equals#true' && (
                                    <>
                                        <Typography component={'label'} className="re-formgroup-label-sm" >Value</Typography>
                                        <AsyncSelectInput
                                            fetchFn={asyncFetchFn}
                                            filterObj={filterObj}
                                            defaultValue={filterValues}
                                            handleChange={e => handleValuesChange(e, operator,filterObj)}
                                        />
                                    </>
                                )
                            }
                        </>
                    </FormControl>
                </Grid>
            )
        }
        
        {
            filterObj && filterObj.extraFilters && filterObj.extraFilters.length > 0 && 
            <>
                <Grid item xs={12}><Divider style={{marginBottom: '15px'}} /></Grid>
                
                <Grid item xs={12}>
                    {
                        filterObj.extraFilters.map((extraFilterObj,index) => (
                            <AdditionalFilterForm key={`extra-filters-${index}`} fieldType={filterObj.fieldType} conditionType={filterObj.conditionType} onFieldChange={onExtraFieldChange} filterObj={extraFilterObj} fieldList={fieldList} filterIndex={index} />
                        ))
                    }
                </Grid>
            </>
            
        }
        
        <Grid item xs={12} style={{marginTop: '-10px'}}>
            <Link onClick={onAdditionalFilter} underline="none" className="re-link-small-primary">
                {'+ Advanced filter'}
            </Link>
        </Grid>

        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className="modal-root"
            open={deletePopup}
            onClose={() => setDeletePopup(false)}
            closeAfterTransition
        >
            <Fade in={deletePopup}>
                <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
                    <Box className="modal-content-simple">
                        <Typography variant="subtitle1" className="modal-heading-title-simple">{`Are you sure to delete this Filter ?`}</Typography>
                        <Box className="modal-footer-simple">
                            <Button onClick={handleCancelDelete} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                            <Button onClick={onDeleteFilter} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Delete </Button>
                        </Box>
                    </Box>
                </Box>
            </Fade>
        </Modal>
    </Grid>
}

export default memo(ReportFilterFormNew)